import instance from "@/services/api";

export const tierReasonAPI = {
  async getReasons() {
    return await instance().get('/tier/reason/read/').then(res => res?.data)
  },
  async getReason(reason_id) {
    return await instance().get(`/tier/reason/get/${reason_id}/`).then(res => res?.data)
  },
  async insertReason(data) {
    return await instance().post('/tier/reason/insert/', data).then(res => res?.data)
  },
  async updateReason(data) {
    return await instance().post('/tier/reason/update/', data).then(res => res?.data)
  },
  async deleteReason(reason_id) {
    return await instance().delete(`/tier/reason/delete/${reason_id}/`).then(res => res?.data)
  }
}

